"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProofOfPlay = exports.addProofOfPlayItemToStorage = exports.getProofOfPlayItemsFromStorage = exports.clearProofOfPlayStorage = void 0;
const feeds_1 = require("../types/feeds");
const media_1 = require("../types/media");
const playlists_1 = require("../types/playlists");
const products_1 = require("../types/products");
const productsPharmacy_1 = require("../types/productsPharmacy");
const productsPricer_1 = require("../types/productsPricer");
const PROOF_OF_PLAY_LOCAL_STORAGE_ITEMS_ATTRIBUTE_NAME = 'proofOfPlayItems';
const clearProofOfPlayStorage = () => {
    localStorage.removeItem(PROOF_OF_PLAY_LOCAL_STORAGE_ITEMS_ATTRIBUTE_NAME);
};
exports.clearProofOfPlayStorage = clearProofOfPlayStorage;
const getProofOfPlayItemsFromStorage = () => {
    const items = localStorage.getItem(PROOF_OF_PLAY_LOCAL_STORAGE_ITEMS_ATTRIBUTE_NAME);
    return typeof items === 'string' && items !== 'undefined'
        ? JSON.parse(items)
        : [];
};
exports.getProofOfPlayItemsFromStorage = getProofOfPlayItemsFromStorage;
const addProofOfPlayItemToStorage = (item) => {
    const items = getProofOfPlayItemsFromStorage();
    items.push(item);
    localStorage.setItem(PROOF_OF_PLAY_LOCAL_STORAGE_ITEMS_ATTRIBUTE_NAME, JSON.stringify(items));
};
exports.addProofOfPlayItemToStorage = addProofOfPlayItemToStorage;
const getProductNameFromProductItem = (item) => {
    const product = item.products[0];
    if (product) {
        if ((0, products_1.isGeneralRetailProduct)(product) || (0, products_1.isRetailProduct)(product) || (0, productsPharmacy_1.isPharmacyProduct)(product)) {
            return product.name;
        }
        else if ((0, productsPricer_1.isPricerProduct)(product)) {
            return product.itemName;
        }
    }
    return 'not-found';
};
const getPlayerProductsIds = (products) => {
    if (products) {
        const ids = products
            .map(product => {
            if ((0, products_1.isRetailProduct)(product) || (0, products_1.isGeneralRetailProduct)(product)) {
                return product.productId;
            }
            else if ((0, productsPricer_1.isPricerProduct)(product)) {
                return product.itemId;
            }
            else if ((0, feeds_1.isPlayerOffer)(product)) {
                return product.id;
            }
            else if (product.ean) {
                return product.ean;
            }
            return undefined;
        })
            .filter(p => p);
        return ids;
    }
};
/**
 * Create proof of play item in screen that can be send to screens-api-
 */
const createProofOfPlay = ({ playlistItem, screen, revolverIndex, lastPlayCalledAt, currentPlayCalledAt, id }) => {
    var _a, _b, _c, _d;
    const { environmentId, screenId, code, rotation, 
    // 'playlist' prop exist only in screen if screen contains only playlist and not channels
    playlist: screenPlaylist, channelIds: screenChannelIds, name: screenName } = screen;
    const { type, itemId: playlistItemId, interval, playlistId: channelPlaylistId, playlistEnvironmentId: channelPlaylistEnvironmentId, channelId, channelName, playlistName: channelPlaylistName } = playlistItem;
    // NOTE: playlist or channel migth be from different environment
    const channelEnvironmentId = (_a = screenChannelIds === null || screenChannelIds === void 0 ? void 0 : screenChannelIds.find(c => c.channelId === channelId)) === null || _a === void 0 ? void 0 : _a.environmentId;
    // Proof of Play item can only belong to playlist or channel
    const itemSourceIds = channelId && channelPlaylistId && channelEnvironmentId
        ? {
            // CASE 1.
            // when item comes from publishing channel's playlist
            channelId,
            channelEnvironmentId,
            channelName,
            playlistId: channelPlaylistId,
            // NOTE: currently channels can have only playlists from the same environment.
            playlistEnvironmentId: channelEnvironmentId,
            playlistName: channelPlaylistName
        }
        : {
            // CASE 2.
            // when screen does not have channel but have playlist linked to it.
            ...(screenPlaylist
                ? {
                    playlistId: screenPlaylist.playlistId,
                    playlistName: screenPlaylist.name,
                    playlistEnvironmentId: screenPlaylist.environmentId
                }
                : {
                    // CASE 3.
                    // when screen has channels and playlist linked to it. Then screenPlaylist does not exist because playlist items are added to screen.channels[0].playlistItems.
                    playlistId: channelPlaylistId,
                    // NOTE: currently channels can have only playlists from the same environment.
                    playlistEnvironmentId: channelPlaylistEnvironmentId, // see screens-api 'convertPlaylistItemsToChannelPlaylistItems' function.
                    playlistName: channelPlaylistName
                })
        };
    const duration = currentPlayCalledAt - lastPlayCalledAt;
    const itemInterval = interval || (screenPlaylist === null || screenPlaylist === void 0 ? void 0 : screenPlaylist.defaultInterval);
    const proofOfPlay = {
        id,
        environmentId,
        screenId,
        screenName,
        code,
        startDate: new Date(lastPlayCalledAt).toISOString(),
        endDate: new Date(currentPlayCalledAt).toISOString(),
        duration,
        rotation,
        type,
        playlistItemId,
        ...(channelId ? { channelId } : {}),
        ...itemSourceIds
    };
    switch (type) {
        case playlists_1.PlaylistItemType.image: {
            const { key, name } = playlistItem;
            return {
                ...proofOfPlay,
                key,
                name,
                interval: itemInterval
            };
        }
        case playlists_1.PlaylistItemType.video: {
            const { key, name } = playlistItem;
            // note: video playlistItem.duration is not stored at the moment.
            return {
                ...proofOfPlay,
                key,
                name
            };
        }
        case playlists_1.PlaylistItemType.list: {
            const { listId, listName, template, products } = playlistItem;
            return {
                ...proofOfPlay,
                listId,
                name: listName,
                templateId: template === null || template === void 0 ? void 0 : template.templateId,
                templateEnvironmentId: template === null || template === void 0 ? void 0 : template.environmentId,
                templateName: template === null || template === void 0 ? void 0 : template.name,
                productIds: getPlayerProductsIds(products),
                interval: itemInterval
            };
        }
        case playlists_1.PlaylistItemType.product: {
            const { template, productId } = playlistItem;
            return {
                ...proofOfPlay,
                templateId: template === null || template === void 0 ? void 0 : template.templateId,
                templateEnvironmentId: template === null || template === void 0 ? void 0 : template.environmentId,
                templateName: template === null || template === void 0 ? void 0 : template.name,
                productIds: [productId],
                name: getProductNameFromProductItem(playlistItem),
                interval: itemInterval
            };
        }
        case playlists_1.PlaylistItemType.batchProducts: {
            const { template, productIds, additionalProps } = playlistItem;
            return {
                ...proofOfPlay,
                templateId: template === null || template === void 0 ? void 0 : template.templateId,
                templateEnvironmentId: template === null || template === void 0 ? void 0 : template.environmentId,
                templateName: template === null || template === void 0 ? void 0 : template.name,
                productIds,
                name: (additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.name) || 'not-found',
                interval: itemInterval
            };
        }
        case playlists_1.PlaylistItemType.url:
            const { url } = playlistItem;
            return {
                ...proofOfPlay,
                name: url,
                interval: itemInterval
            };
        case playlists_1.PlaylistItemType.infopage:
            const { infopage, infopageId } = playlistItem;
            return {
                ...proofOfPlay,
                templateId: (_b = infopage === null || infopage === void 0 ? void 0 : infopage.template) === null || _b === void 0 ? void 0 : _b.templateId,
                templateEnvironmentId: (_c = infopage === null || infopage === void 0 ? void 0 : infopage.template) === null || _c === void 0 ? void 0 : _c.environmentId,
                templateName: (_d = infopage === null || infopage === void 0 ? void 0 : infopage.template) === null || _d === void 0 ? void 0 : _d.name,
                infopageId,
                name: (infopage === null || infopage === void 0 ? void 0 : infopage.name) || 'not-found',
                interval: itemInterval
            };
        case playlists_1.PlaylistItemType.content:
            const { content, contentId } = playlistItem;
            return {
                ...proofOfPlay,
                contentId,
                name: content.name,
                interval: itemInterval
            };
        case playlists_1.PlaylistItemType.revolver: {
            if (revolverIndex) {
                const { itemId, revolverItems, name } = playlistItem;
                const revolverItemIndex = revolverIndex[itemId];
                const revolverItem = revolverItems[revolverItemIndex];
                if (revolverItem) {
                    return {
                        ...proofOfPlay,
                        key: revolverItem.key,
                        name: revolverItem.name || 'not-found',
                        revolverName: name,
                        interval: revolverItem.type === media_1.MediaType.image ? itemInterval : undefined
                    };
                }
            }
        }
    }
    return proofOfPlay;
};
exports.createProofOfPlay = createProofOfPlay;
//# sourceMappingURL=proofOfPlay.js.map